import React from "react";

export const LegDetailContext = React.createContext(null);

export const useLegDetailContext = () => {
    const context = React.useContext(LegDetailContext);

    if (!context) throw new Error("Leg Detail Context not provided!");

    return context;
};